import { StarFilled, StarOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';

import { Container } from './StarSwitch.styles';

export interface Starrable {
  isStarred: boolean;
  toggleStarred: () => void;
}

export interface StarSwitchProps {
  store: Starrable;
}

function StarSwitch({ store }: StarSwitchProps) {
  return (
    <Container
      onClick={(e) => {
        e.stopPropagation();
        store.toggleStarred();
      }}
      onMouseUp={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {store?.isStarred ? <StarFilled /> : <StarOutlined />}
    </Container>
  );
}

export default observer(StarSwitch);
